import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-scroll';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWindows as fabFaWindows,
  faApple as fabFaApple,
  faLinux as fabFaLinux,
} from '@fortawesome/free-brands-svg-icons';

import 'Features/Bundle/components/Cards/TieredBundleFreeGameCard.scss';

import Drm from 'Components/Utility/Drm';
import FluidImg from 'Components/Utility/FluidImg';

export default function TieredBundleFreeGameCard({ game, switchCarouselGame }) {
  const validDrm = Object.keys(game.drm).filter(d => game.drm[d]);
  const validPlatforms = Object.keys(game.platforms).filter(p => game.platforms[p]);

  return (
    <React.Fragment>
      <article className="bundle-free-game-container faux-block-link">
        <div className="image-container">
          <FluidImg
            src={game.cover}
            alt={name}
          />
        </div>
        <div className="content-container">
          <h3 className="game-name">
            <Link
              spy
              smooth
              offset={-120}
              activeClass="active"
              to="carousel"
              duration={500}
              className="faux-block-link__overlay-link"
              onClick={() => { switchCarouselGame(game.totalGameIndex); }}
            >
              <FormattedMessage id="tiered-bundle-game.tiered-one" defaultMessage="Tier 1 - Free game - " />
              {game.name}
            </Link>
          </h3>
          <div className="icon-price-container">
            <div className="icon-container">
              <Drm drmType={validDrm[0]} />
              <div className="d-none d-lg-block">
                <div className="platform-container">
                  {validPlatforms.reverse().map(p =>
                    <span key={p}>
                      {p === 'windows' &&
                        <FontAwesomeIcon icon={fabFaWindows} className="mr-2" />
                      }
                      {p === 'mac' &&
                        <FontAwesomeIcon icon={fabFaApple} className="mr-2" />
                      }
                      {p === 'linux' &&
                        <FontAwesomeIcon icon={fabFaLinux} className="mr-2" />
                      }
                    </span>,
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ribbon">
          <span>
            <FormattedMessage id="tiered-bundle-game.free" defaultMessage="FREE" />
          </span>
        </div>
      </article>
    </React.Fragment>
  );
}

TieredBundleFreeGameCard.propTypes = {
  game: PropTypes.shape({}),
  switchCarouselGame: PropTypes.func,
};

TieredBundleFreeGameCard.defaultProps = {
  game: {},
  switchCarouselGame: () => { },
};
